export const DEVEX_REVIEW_LATENCY_MAX_DAYS = 120;
export const DEVEX_CODEX_FEEDBACK_MAX_DAYS = 120;
